<template>
	<div id='btn_tuij'>
		<a-popover :visible="visible" placement="leftTop" trigger="click" :destroyTooltipOnHide="true"
			:overlayStyle="{width:'calc(8rem)'}" @visibleChange="moreEvent()"
			:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
			<template slot="content">
				<div style="padding: .5rem;background: #fff;">
					<div class="warp_title">
					<div>
						<div @click='onChange("drop")'>
							<a-icon type="delete" style='color: #ee5253;font-size: .8rem;'/> 删除
						</div>
					</div>
					<div >
						<div @click='onChange(2)'>
							<a-icon type="pause-circle" style='color: #ffab50;font-size: .8rem;'/> 暫停
						</div>
					</div>
					<div>
						<div @click='onChange(1)'>
							<a-icon type="play-circle"  style='color: #3bc7a1;font-size: .8rem;'/> 重新啟用
						</div>
					</div>
				</div>
				</div>
				
			</template>
			<img :src="visible ? icon_gengduo1 : icon_gengduo" class="imageC">
		</a-popover>
	</div>
</template>

<script>
	import icon_gengduo from '@/image/icon_gengduo.png';
	import icon_gengduo1 from '@/image/icon_gengduo1.png';
	import App from '@/assets/app.js';
	export default {
		props: ['record', 'params'],
		data() {
			return {
				icon_gengduo,
				icon_gengduo1,
				visible: false,
				IconShang: require('@/image/icon_shang.png'),
				tswitch: true,
				hotswitch: true,
			}
		},
		created() {
			if (this.record.hot_status == 1) {
				this.hotswitch = false
			} else if (this.record.hot_status == 2) {
				this.tswitch = false
			} else {
				this.hotswitch = false
				this.tswitch = false
			}

		},
		methods: {
			onChange(checked) {
				this.$ajax({
					method: 'post',
					url: this.$api.editKh,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"inviterid":this.record.inviterid,
						"status": checked
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', true)
						this.visible = false
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			//彈出前操作
			moreEvent() {
				// console.log(this.$store.state.rolesdata.indexOf('ipoAduitAdmin'))
				if (this.visible) {
					this.visible = false
				} else {
					this.visible = true
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	#warp_div {
		.ant-switch-checked {
			background-color: #1890ff;
		}

		.warp_uimg {
			text-align: right;
			img {
				cursor: pointer;
				width: 1rem;
			}
		}
	}

	.warp_title>div {
		padding: .4rem .5rem;
		color: #000;
		border-bottom: 1px solid #e8e8e8;
	}
	.warp_title>div:last-child {
		border-bottom: 0;
		}
	.warp_title {
		paddding: 8px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
	}
</style>
